import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as hostedFields from 'braintree-web/hosted-fields';
import { PrintService } from '../../../../services/print.service';
import { CountriesService } from '../../../../services/countries.service';
import { environment } from 'environments/environment';
import { FirebaseService } from 'app/services/firebase.service';

@Component({
  selector: 'add-card',
  styleUrls: [
    '../../../../shared/select/select.component.scss',
    '../../../wizard/wizard.component.scss',
    '../../print.component.scss',
    './addCard.component.scss',
  ],
  templateUrl: './addCard.component.html',
})
export class AddCardComponent implements OnInit {
  @Input() showList;
  @Input() submitCard;
  @Input() next;
  @Input() prev;
  @Input() setPaymentStepView;

  isFormReady = false;
  isFormInitialized = false;
  hostedFieldsInstance;
  deviceData;
  tokenizationOptions: any = {
    billingAddress: {},
  };
  storyId;
  countries = this.countriesService.countries;
  sameAsShipping = true;
  formErrors: any = {};
  showPrivacyModal;
  privacyPolicyLink = environment.privacyPolicyLink;
  saveForFutureUse = false;

  constructor(
    private printService: PrintService,
    private countriesService: CountriesService,
    private firebaseService: FirebaseService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    this.storyId = this.activatedRoute.snapshot.params.id;
    this.createHostedFields();
    const address = { ...this.printService.shippingAddress };
    this.tokenizationOptions.cardholderName = `${address.first_name} ${address.last_name}`;
    this.prefillBillingAddress();
  }

  prefillBillingAddress() {
    const address = { ...this.printService.shippingAddress };
    this.tokenizationOptions = {
      ...this.tokenizationOptions,
      billingAddress: {
        id: this.sameAsShipping ? address.id : undefined,
        first_name: address.first_name,
        last_name: address.last_name,
        line1: address.line1,
        line2: address.line2,
        country_code: address.country_code,
        zip_code: address.zip_code,
        city: address.city,
        phone_number: address.phone_number,
        state: address.state,
      },
    };
  }

  createHostedFields() {
    const options = {
      client: this.printService.braintreeClientInstance,
      fields: {
        number: {
          selector: '#card_number',
        },
        cvv: {
          selector: '#security_code',
        },
        expirationMonth: {
          selector: '#expiration-month',
          select: true,
        },
        expirationYear: {
          selector: '#expiration-year',
          select: true,
        },
      },
      styles: {
        'input, select': {
          'font-size': '16px',
          color: '#26251e',
          'font-family': 'sans-serif',
        },
      },
    };

    hostedFields.create(options, (err, hostedFieldsInstance) => {
      this.hostedFieldsInstance = hostedFieldsInstance;
      this.isFormReady = true;
      this.isFormInitialized = true;
    });
  }

  displaySelectedCountry(country) {
    return country.name;
  }

  onCountryChanged(key) {
    this.tokenizationOptions.billingAddress.country_code = key;
  }

  onSameAsShippingChange() {
    this.prefillBillingAddress();
  }

  togglePrivacyModal() {
    this.showPrivacyModal = !this.showPrivacyModal;
  }

  submit() {
    this.isFormReady = false;
    this.hostedFieldsInstance.tokenize((err, payload) => {
      if (err && err.details) {
        this.isFormReady = true;
        this.formErrors = {};
        err.details.invalidFieldKeys.forEach(error => {
          this.formErrors[error] = 'invalid';
        });
        this.firebaseService.logEvent('checkout_payment_method_error', {
          print_order_id: this.printService.printOrder.id,
          story_id: this.printService.storyId,
          project_id: this.printService.projectId,
          reason: err.message,
        });
        return null;
      }
      const params = {
        nonce: payload.nonce,
        device_data: this.printService.deviceData,
        billing_address: this.tokenizationOptions.billingAddress,
        cardholder_name: this.tokenizationOptions.cardholderName,
      };

      this.printService.createPaymentMethod(params).subscribe(
        card => {
          this.firebaseService.logEvent('checkout_payment_method_add', {
            story_id: this.printService.storyId,
            print_order_id: this.printService.printOrder.id,
            project_id: this.printService.projectId,
          });
          this.submitCard(card, this.saveForFutureUse);
        },
        response => {
          this.isFormReady = true;
          this.formErrors = response.error;
        }
      );
    });
  }
}
